import React from "react";
import { node, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import Paragraph from "../Paragraph";
import LandingSimpleSection from "../LandingElement/SimpleSection";

export const PlasmidElementSectionBreadcrumbs = ({ children }) => (
	<LandingSimpleSection className="py-5" isBorderNone>
		<LandingSimpleSection.Body>{children}</LandingSimpleSection.Body>
	</LandingSimpleSection>
);

PlasmidElementSectionBreadcrumbs.propTypes = {
	children: node.isRequired,
};

export const PlasmidElementSetTitleLink = ({ href, children, ...props }) => (
	<Paragraph Tag="div" sx={{ fontSize: "l", fontColor: "2" }}>
		<Link href={href} {...props}>
			{children}
		</Link>
	</Paragraph>
);

PlasmidElementSetTitleLink.propTypes = {
	href: string.isRequired,
	children: node.isRequired,
};

export const PlasmidElementSetDescription = ({ ...props }) => <Paragraph Tag="div" {...props} />;
